import { Box, styled, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import BaseYearMessage from '@Router/EsgGreenhouse/Components/BaseYearMessage';
import GasEmissionMessage from '@Router/EsgGreenhouse/Components/GasEmissionMessage';
import { ICarbonDetailFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import dayjs from 'dayjs';
import { OrganizationType } from 'src/Enum/EsgGreenhouse';
import CarbonActions from './CarbonActions';

export interface ICarbonEditModeState {
  mode: 'create' | 'edit';
  data?: ICarbonDetailFormValues;
  index?: number;
}
export enum CABON_NEUTRALITY_TABLE_COLUMNS {
  ID = 'id',
  SCOPE = 'scope',
  BASE_YEAR = 'baseYear',
  TARGET_YEAR = 'target',
  GAS_EMISSIONS_QUANTITY = 'gasEmissionsQuantity',
  GOAL_STANDARTS_SETTING = 'organization',
  ACTION = 'action',
}

export const CABON_NEUTRALITY_VISIBILITY = {
  [CABON_NEUTRALITY_TABLE_COLUMNS.ID]: false,
};
const UnorderList = styled('ul')(({ theme }) => ({
  margin: 0,
  paddingLeft: theme.spacing(3),
}));

export const CABON_NEUTRALITY_COLUMNS: GridColDef[] = [
  { field: CABON_NEUTRALITY_TABLE_COLUMNS.ID, headerName: 'No.' },
  {
    field: CABON_NEUTRALITY_TABLE_COLUMNS.SCOPE,
    headerName: 'ขอบเขตการปล่อยก๊าซเรือนกระจก',
    minWidth: 175,
    flex: 1,
    renderCell: (fields) => {
      const { value } = fields;
      return (
        <Box>
          <Typography>{value.nameScopeTh}</Typography>
          <Typography mt={2}>{value.nameScopeEn}</Typography>
        </Box>
      );
    },
  },
  {
    field: CABON_NEUTRALITY_TABLE_COLUMNS.BASE_YEAR,
    headerName: 'ปีฐาน',
    minWidth: 175,
    flex: 1,
    renderCell: ({ value }) => {
      const { year, gasEmissionQuantity } = value || {};

      return (
        <BaseYearMessage
          year={year}
          gasEmissionQuantity={gasEmissionQuantity}
        />
      );
    },
  },
  {
    field: CABON_NEUTRALITY_TABLE_COLUMNS.TARGET_YEAR,
    headerName: 'ปีเป้าหมาย',
    minWidth: 175,
    flex: 1,
    renderCell: ({ value }) => {
      const { year, gasEmissionPercent, gasEmissionQuantity } = value;
      const baseYear = dayjs(year).get('year');
      return (
        <GasEmissionMessage
          year={baseYear}
          percent={gasEmissionPercent}
          quantity={gasEmissionQuantity}
        />
      );
    },
  },
  {
    field: CABON_NEUTRALITY_TABLE_COLUMNS.GOAL_STANDARTS_SETTING,
    headerName: 'การรับรอง',
    minWidth: 175,
    flex: 1,
    renderCell: (fields) => {
      const { value } = fields;
      const hasOrganization = value.organizationId !== undefined;
      const isOtherOrganization =
        value.organizationId === OrganizationType.OTHER_GHG_MGNT_ORGANIZATION;

      if (!hasOrganization) {
        return <Typography>-</Typography>;
      }

      return (
        <Box>
          {isOtherOrganization ? (
            <Box>
              <Typography>อื่น ๆ</Typography>
              <UnorderList>
                <Typography component="li">
                  {value.organizationTh || ''}
                </Typography>
              </UnorderList>
              <Typography mt={1}>Other</Typography>
              <UnorderList>
                <Typography component="li">
                  {value.organizationEn || ''}
                </Typography>
              </UnorderList>
            </Box>
          ) : (
            <Box>
              <Typography>{value.organizationTh}</Typography>
              <Typography mt={1}>{value.organizationEn}</Typography>
            </Box>
          )}
        </Box>
      );
    },
  },
  {
    field: 'action',
    headerName: 'แก้ไข/ลบ',
    headerAlign: 'left',
    type: 'actions',
    minWidth: 60,
    getActions: (field) => {
      const { id } = field;
      return [<CarbonActions rowId={id} />];
    },
  },
];
